import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd/modal';
import { HttpService } from 'src/app/service/http.service';
import { StorageService } from 'src/app/service/storage.service';
import { TimeXService } from 'src/app/service/TimeX.service';
import { Md5 } from 'ts-md5';

@Component({
  selector: 'app-header2_en',
  templateUrl: './header2_en.component.html',
  styleUrls: ['./header2_en.component.css']
})
export class Header2_enComponent implements OnInit {
  userinfo:any;
  isThemeEnd = false;

  constructor(
    public http: HttpService,
    private router: Router,
    private local: StorageService,
    private modal: NzModalService,
    private timex: TimeXService,
  ) { 
    if (typeof window !== 'undefined') {
      if(local.get('userinfo')){
        this.userinfo = local.get('userinfo');
      }
    }
    timex.getTimeX();
    this.isThemeEnd = timex.isThemeEnd;
  }

  ngOnInit() {
  }


  //退出登录
  logout(){
    let signature = Md5.hashStr('CYYbQyB7FdIS8xuBEwVwbBDMQKOZPMXK|' + new Date().getTime().toString().substr(0, 10) + '|logout');
    var api = 'user/user/logout';
    var body = {
      'timestamp': new Date().getTime().toString().substr(0, 10),
      'signature': signature,
      'sessionid': this.userinfo.sessionid,
      'user_id':this.userinfo.id
    }
    this.http.doPost(api, body, (result) => {
      // console.log(result);
      if (result.code == "200") {
        this.local.remove('userinfo');
        this.router.navigate(['/en']);
      } else {
        this.modal.error({
          nzTitle: "网站提示",
          nzContent: result.message,
          nzOkText: "关闭",
          nzOnOk: () => { },
        })
      }
    })
    
  }


}
